import { create } from 'zustand';

type TestFlagsStore = {
  aiDeliverablesErrorTestMode: boolean;
  setAIDeliverablesErrorTestMode: (value: boolean) => void;
};

export const testFlagsStore = create<TestFlagsStore>()(set => ({
  aiDeliverablesErrorTestMode: false,
  setAIDeliverablesErrorTestMode: (value: boolean) =>
    set(() => ({
      aiDeliverablesErrorTestMode: value
    }))
}));

export const useTestFlagsStore = <T>(selector: (state: TestFlagsStore) => T): T => testFlagsStore(selector);
